// proyecto original para produccion Farmacias.

// Passphrase
const passphrase = 'base64:IES06ldztmFbjoPQnUvnMrUiZrJLMPi8GbxxhqSTKLQ=';

// URL local host docker
const baseDevLocal = 'http://localhost:80/api/';

// const baseDevLocal = process.env.REACT_APP_API;


// URL local host laragon
// const baseDevLocal = 'http://pos-backend.test/api/';


// url produccion dockerizada
const baseProd = 'https://api-pos.midata.ai/api/';

// url produccion desarrollo dockerizada 
const baseDev = 'https://api-pos.midata.ai/api/';

const production = {
    login: `${baseProd}auth/login`,
    logout: `${baseProd}auth/logout`,
    refresh: `${baseProd}auth/refresh`,
    reset: `${baseProd}auth/reset`,
    currentUser: `${baseProd}auth/me`,
    apiforceLogout: `${baseProd}auth/force-logout`,
    companies: `${baseProd}companies`,
    platformSettings: `${baseProd}platform-settings`,
    companies_options: `${baseProd}companies-options`,
    companies_option_hondura: `${baseProd}companies-option-hondura`,
    countries: `${baseProd}countries`,
    countries_options: `${baseProd}countries-options`,
    currencies: `${baseProd}currencies`,
    currencies_options: `${baseProd}currencies-options`,
    users: `${baseProd}users`,
    stores: `${baseProd}stores`,
    stores_options: `${baseProd}stores-options`,
    stores_category: `${baseProd}product-change-price-location`,
    data_changeprice: store => `${baseProd}product-change-price-location/${store}`,
    discounts_options: `${baseProd}discounts-options`,
    storeType: `${baseProd}store-types`,
    storeType_options: `${baseProd}store-types-options`,
    storeChain: `${baseProd}store-chains`,
    storeChain_options: `${baseProd}store-chains-options`,
    storeFlag: `${baseProd}store-flags`,
    storeFlag_options: `${baseProd}store-flags-options`,
    Location: `${baseProd}location-types`,
    Location_options: `${baseProd}location-types-options`,
    storeFormat: `${baseProd}store-formats`,
    storeFormat_options: `${baseProd}store-formats-options`,
    socioeconomicLevel: `${baseProd}socioeconomic-levels`,
    socioeconomicLevel_options: `${baseProd}socioeconomic-levels-options`,
    states: `${baseProd}states`,
    states_options: `${baseProd}states-options`,
    Zones: `${baseProd}zones`,
    Zones_options: `${baseProd}zones-options`,
    Municipality: `${baseProd}municipalities`,
    Municipality_options: `${baseProd}municipalities-options`,
    Region: `${baseProd}regions`,
    Client: `${baseProd}clients`,
    Client_options: `${baseProd}clients-options`,
    Makers: `${baseProd}makers`,
    Uoms: `${baseProd}uoms`,
    Uoms_options: `${baseProd}uoms-options`,
    Brands: `${baseProd}brands`,
    Brands_options: `${baseProd}brands-options`,
    ActivePrinciple: `${baseProd}product-active-principle`,
    Providers: `${baseProd}providers`,
    Providers_options: `${baseProd}providers-options`,
    ProductDepartament: `${baseProd}product-departments`,
    ProductCategory: `${baseProd}product-categories`,
    ProductCategory_options: `${baseProd}product-categories-options`,
    ProductSubCategory: `${baseProd}product-subcategories`,
    ProductSubCategory_options: `${baseProd}product-subcategories-options`,
    products: `${baseProd}products`,
    products_options: `${baseProd}products-options`,
    productCategories: `${baseProd}product-categories`,
    productSubCategories: `${baseProd}product-subcategories`,
    brands: `${baseProd}brands`,
    uoms: `${baseProd}uoms`,
    locationType: `${baseProd}location-types`,
    internalCorrelative: `${baseProd}store-correlative`,
    paymentMethod: `${baseProd}payment-methods`,
    paymentMethod_options: `${baseProd}payment-methods-options`,
    Turns: `${baseProd}turns`,
    Turns_options: `${baseProd}turns-options`,
    Presentations: `${baseProd}presentations`,
    Presentations_options: `${baseProd}presentations-options`,
    Skus: `${baseProd}presentation-skus`,
    SkusOptions: `${baseProd}presentation-skus-options`,
    discounts: `${baseProd}discounts`,
    Combos: `${baseProd}presentation-combos`,
    permissions: `${baseProd}permissions`,
    userPermissions: userId => `${baseProd}users/${userId}/permissions`,
    transfers: `${baseProd}transfers`,
    orders: `${baseProd}orders`,
    counts: `${baseProd}stock-counts`,
    countsAdjustments: `${baseProd}stock-counts-adjustments`,
    purchases: `${baseProd}purchases`,
    inventory: `${baseProd}stocks`,
    adjustments: `${baseProd}adjustments`,
    roles: `${baseProd}roles-options`,
    deposits: `${baseProd}deposits`,
    storeTurns: `${baseProd}store-turns`,
    sells: `${baseProd}sells`,
    quotes: `${baseProd}quotes`,
    sellsOffline: `${baseProd}sells-offline`,
    sellPayments: `${baseProd}sell-payments`,
    cashAdjustment: `${baseProd}cash-adjustments`,
    UpdatePricePresentation: `${baseProd}product-change-price-location/`,
    storesCash: `${baseProd}stores-cash`,
    productsNotAvailable: `${baseProd}stocks`,
    fels: `${baseProd}fels`,
    felContingencies: `${baseProd}fel-contingencies`,
    fel_honduras: `${baseProd}fel-honduras`,
    taxes: `${baseProd}taxes`,
    storeTurnsOpen: `${baseProd}store-turn-opens`,
    storeTurnsClose: `${baseProd}store-turn-close`,
    usersSession: `${baseProd}users-session`,
    projects: `${baseProd}projects`,
    stockOptions: `${baseProd}stock-options`,
    userCompaniesStore: `${baseProd}users`,
    userAdminEmpresa: `${baseProd}users-options`,
    productsCsvOptions: `${baseProd}products-csv-options`,
    presentationsCsvOptions: `${baseProd}presentations-csv-options`,
    discountsCsvOptions: `${baseProd}discounts-csv-options`,
    presentationsSkusCsvOptions: `${baseProd}presentations-skus-csv-options`,
    presentationsCombosCsvOptions: `${baseProd}presentations-combos-csv-options`,
    presentationsDiscountsCsvOptions: `${baseProd}presentations-discounts-csv-options`,

    productsCsvImport: `${baseProd}products-csv-import`,
    presentationSkuCsvImport: `${baseProd}presentation-sku-csv-import`,
    discountsCsvImport: `${baseProd}discounts-csv-import`,
    presentationsCsvImport: `${baseProd}presentations-csv-import`,
    presentationsDiscountsCsvImport: `${baseProd}presentations-discounts-csv-import`,

    recipes: `${baseProd}recipes`,
    suggestedProduct: `${baseProd}suggest-products`
}

const develop = {
    login: `${baseDev}auth/login`,
    logout: `${baseDev}auth/logout`,
    refresh: `${baseDev}auth/refresh`,
    reset: `${baseDev}auth/reset`,
    currentUser: `${baseDev}auth/me`,
    apiforceLogout: `${baseDev}auth/force-logout`,
    companies: `${baseDev}companies`,
    platformSettings: `${baseDev}platform-settings`,
    companies_options: `${baseDev}companies-options`,
    companies_option_hondura: `${baseDev}companies-option-hondura`,
    countries: `${baseDev}countries`,
    countries_options: `${baseDev}countries-options`,
    currencies: `${baseDev}currencies`,
    currencies_options: `${baseDev}currencies-options`,
    users: `${baseDev}users`,
    stores: `${baseDev}stores`,
    stores_options: `${baseDev}stores-options`,
    stores_category: `${baseDev}product-change-price-location`,
    data_changeprice: store => `${baseDev}product-change-price-location/${store}`,
    UpdatePricePresentation: `${baseDev}product-change-price-location`,
    discounts_options: `${baseDev}discounts-options`,
    storeType: `${baseDev}store-types`,
    storeType_options: `${baseDev}store-types-options`,
    storeChain: `${baseDev}store-chains`,
    storeChain_options: `${baseDev}store-chains-options`,
    storeFlag: `${baseDev}store-flags`,
    storeFlag_options: `${baseDev}store-flags-options`,
    Location: `${baseDev}location-types`,
    Location_options: `${baseDev}location-types-options`,
    internalCorrelative: `${baseDev}store-correlative`,
    storeFormat: `${baseDev}store-formats`,
    storeFormat_options: `${baseDev}store-formats-options`,
    socioeconomicLevel: `${baseDev}socioeconomic-levels`,
    socioeconomicLevel_options: `${baseDev}socioeconomic-levels-options`,
    states: `${baseDev}states`,
    states_options: `${baseDev}states-options`,
    Zones: `${baseDev}zones`,
    Zones_options: `${baseDev}zones-options`,
    Municipality: `${baseDev}municipalities`,
    Municipality_options: `${baseDev}municipalities-options`,
    Region: `${baseDev}regions`,
    Client: `${baseDev}clients`,
    Client_options: `${baseDev}clients-options`,
    Makers: `${baseDev}makers`,
    Uoms: `${baseDev}uoms`,
    Uoms_options: `${baseDev}uoms-options`,
    Brands: `${baseDev}brands`,
    Brands_options: `${baseDev}brands-options`,
    ActivePrinciple: `${baseDev}product-active-principle`,
    Providers: `${baseDev}providers`,
    Providers_options: `${baseDev}providers-options`,
    ProductDepartament: `${baseDev}product-departments`,
    ProductCategory: `${baseDev}product-categories`,
    ProductCategory_options: `${baseDev}product-categories-options`,
    ProductSubCategory: `${baseDev}product-subcategories`,
    ProductSubCategory_options: `${baseDev}product-subcategories-options`,
    products: `${baseDev}products`,
    products_options: `${baseDev}products-options`,
    productCategories: `${baseDev}product-categories`,
    productSubCategories: `${baseDev}product-subcategories`,
    brands: `${baseDev}brands`,
    uoms: `${baseDev}uoms`,
    locationType: `${baseDev}location-types`,
    paymentMethod: `${baseDev}payment-methods`,
    paymentMethod_options: `${baseDev}payment-methods-options`,
    Turns: `${baseDev}turns`,
    Turns_options: `${baseDev}turns-options`,
    Presentations: `${baseDev}presentations`,
    Presentations_options: `${baseDev}presentations-options`,
    Skus: `${baseDev}presentation-skus`,
    SkusOptions: `${baseDev}presentation-skus-options`,
    discounts: `${baseDev}discounts`,
    Combos: `${baseDev}presentation-combos`,
    permissions: `${baseDev}permissions`,
    userPermissions: userId => `${baseDev}users/${userId}/permissions`,
    transfers: `${baseDev}transfers`,
    orders: `${baseDev}orders`,
    counts: `${baseDev}stock-counts`,
    countsAdjustments: `${baseDev}stock-counts-adjustments`,
    purchases: `${baseDev}purchases`,
    inventory: `${baseDev}stocks`,
    adjustments: `${baseDev}adjustments`,
    roles: `${baseDev}roles-options`,
    deposits: `${baseDev}deposits`,
    storeTurns: `${baseDev}store-turns`,
    sells: `${baseDev}sells`,
    quotes: `${baseDev}quotes`,
    sellsOffline: `${baseDev}sells-offline`,
    sellPayments: `${baseDev}sell-payments`,
    cashAdjustment: `${baseDev}cash-adjustments`,
    storesCash: `${baseDev}stores-cash`,
    productsNotAvailable: `${baseDev}stocks`,
    fels: `${baseDev}fels`,
    felContingencies: `${baseDev}fel-contingencies`,
    fel_honduras: `${baseDev}fel-honduras`,
    taxes: `${baseDev}taxes`,
    storeTurnsOpen: `${baseDev}store-turn-opens`,
    storeTurnsClose: `${baseDev}store-turn-close`,
    usersSession: `${baseDev}users-session`,
    projects: `${baseDev}projects`,
    stockOptions: `${baseDev}stock-options`,
    userCompaniesStore: `${baseDev}users`,
    userAdminEmpresa: `${baseDev}users-options`,
    productsCsvOptions: `${baseDev}products-csv-options`,
    presentationsCsvOptions: `${baseDev}presentations-csv-options`,
    discountsCsvOptions: `${baseDev}discounts-csv-options`,
    presentationsSkusCsvOptions: `${baseDev}presentations-skus-csv-options`,
    presentationsCombosCsvOptions: `${baseDev}presentations-combos-csv-options`,
    presentationsDiscountsCsvOptions: `${baseDev}presentations-discounts-csv-options`,

    productsCsvImport: `${baseDev}products-csv-import`,
    presentationSkuCsvImport: `${baseDev}presentation-sku-csv-import`,
    discountsCsvImport: `${baseDev}discounts-csv-import`,
    presentationsCsvImport: `${baseDev}presentations-csv-import`,
    presentationsDiscountsCsvImport: `${baseDev}presentations-discounts-csv-import`,

    recipes: `${baseDev}recipes`,
    suggestedProduct: `${baseDev}suggest-products`
}

const localHost = {
    login: `${baseDevLocal}auth/login`,
    logout: `${baseDevLocal}auth/logout`,
    refresh: `${baseDevLocal}auth/refresh`,
    reset: `${baseDevLocal}auth/reset`,
    currentUser: `${baseDevLocal}auth/me`,
    apiforceLogout: `${baseDevLocal}auth/force-logout`,
    companies: `${baseDevLocal}companies`,
    platformSettings: `${baseDevLocal}platform-settings`,
    companies_options: `${baseDevLocal}companies-options`,
    companies_option_hondura: `${baseDevLocal}companies-option-hondura`,
    countries: `${baseDevLocal}countries`,
    countries_options: `${baseDevLocal}countries-options`,
    currencies: `${baseDevLocal}currencies`,
    currencies_options: `${baseDevLocal}currencies-options`,
    users: `${baseDevLocal}users`,
    stores: `${baseDevLocal}stores`,
    stores_options: `${baseDevLocal}stores-options`,
    stores_category: `${baseDevLocal}product-change-price-location`,
    data_changeprice: store => `${baseDevLocal}product-change-price-location/${store}`,
    UpdatePricePresentation: `${baseDevLocal}product-change-price-location`,
    discounts_options: `${baseDevLocal}discounts-options`,
    storeType: `${baseDevLocal}store-types`,
    storeType_options: `${baseDevLocal}store-types-options`,
    storeChain: `${baseDevLocal}store-chains`,
    storeChain_options: `${baseDevLocal}store-chains-options`,
    storeFlag: `${baseDevLocal}store-flags`,
    storeFlag_options: `${baseDevLocal}store-flags-options`,
    Location: `${baseDevLocal}location-types`,
    Location_options: `${baseDevLocal}location-types-options`,
    internalCorrelative: `${baseDevLocal}store-correlative`,
    storeFormat: `${baseDevLocal}store-formats`,
    storeFormat_options: `${baseDevLocal}store-formats-options`,
    socioeconomicLevel: `${baseDevLocal}socioeconomic-levels`,
    socioeconomicLevel_options: `${baseDevLocal}socioeconomic-levels-options`,
    states: `${baseDevLocal}states`,
    states_options: `${baseDevLocal}states-options`,
    Zones: `${baseDevLocal}zones`,
    Zones_options: `${baseDevLocal}zones-options`,
    Municipality: `${baseDevLocal}municipalities`,
    Municipality_options: `${baseDevLocal}municipalities-options`,
    Region: `${baseDevLocal}regions`,
    Client: `${baseDevLocal}clients`,
    Client_options: `${baseDevLocal}clients-options`,
    Makers: `${baseDevLocal}makers`,
    Uoms: `${baseDevLocal}uoms`,
    Uoms_options: `${baseDevLocal}uoms-options`,
    Brands: `${baseDevLocal}brands`,
    Brands_options: `${baseDevLocal}brands-options`,
    ActivePrinciple: `${baseDevLocal}product-active-principle`,
    Providers: `${baseDevLocal}providers`,
    Providers_options: `${baseDevLocal}providers-options`,
    ProductDepartament: `${baseDevLocal}product-departments`,
    ProductCategory: `${baseDevLocal}product-categories`,
    ProductCategory_options: `${baseDevLocal}product-categories-options`,
    ProductSubCategory: `${baseDevLocal}product-subcategories`,
    ProductSubCategory_options: `${baseDevLocal}product-subcategories-options`,
    products: `${baseDevLocal}products`,
    products_options: `${baseDevLocal}products-options`,
    productCategories: `${baseDevLocal}product-categories`,
    productSubCategories: `${baseDevLocal}product-subcategories`,
    brands: `${baseDevLocal}brands`,
    uoms: `${baseDevLocal}uoms`,
    locationType: `${baseDevLocal}location-types`,
    paymentMethod: `${baseDevLocal}payment-methods`,
    paymentMethod_options: `${baseDevLocal}payment-methods-options`,
    Turns: `${baseDevLocal}turns`,
    Turns_options: `${baseDevLocal}turns-options`,
    Presentations: `${baseDevLocal}presentations`,
    Presentations_options: `${baseDevLocal}presentations-options`,
    Skus: `${baseDevLocal}presentation-skus`,
    SkusOptions: `${baseDevLocal}presentation-skus-options`,
    discounts: `${baseDevLocal}discounts`,
    Combos: `${baseDevLocal}presentation-combos`,
    permissions: `${baseDevLocal}permissions`,
    userPermissions: userId => `${baseDevLocal}users/${userId}/permissions`,
    transfers: `${baseDevLocal}transfers`,
    orders: `${baseDevLocal}orders`,
    counts: `${baseDevLocal}stock-counts`,
    countsAdjustments: `${baseDevLocal}stock-counts-adjustments`,
    purchases: `${baseDevLocal}purchases`,
    inventory: `${baseDevLocal}stocks`,
    adjustments: `${baseDevLocal}adjustments`,
    roles: `${baseDevLocal}roles-options`,
    deposits: `${baseDevLocal}deposits`,
    storeTurns: `${baseDevLocal}store-turns`,
    sells: `${baseDevLocal}sells`,
    quotes: `${baseDevLocal}quotes`,
    sellsOffline: `${baseDevLocal}sells-offline`,
    sellPayments: `${baseDevLocal}sell-payments`,
    cashAdjustment: `${baseDevLocal}cash-adjustments`,
    storesCash: `${baseDevLocal}stores-cash`,
    productsNotAvailable: `${baseDevLocal}stocks`,
    fels: `${baseDevLocal}fels`,
    felContingencies: `${baseDevLocal}fel-contingencies`,
    fel_honduras: `${baseDevLocal}fel-honduras`,
    taxes: `${baseDevLocal}taxes`,
    storeTurnsOpen: `${baseDevLocal}store-turn-opens`,
    storeTurnsClose: `${baseDevLocal}store-turn-close`,
    usersSession: `${baseDevLocal}users-session`,
    projects: `${baseDevLocal}projects`,
    stockOptions: `${baseDevLocal}stock-options`,
    userCompaniesStore: `${baseDevLocal}users`,
    userAdminEmpresa: `${baseDevLocal}users-options`,
    productsCsvOptions: `${baseDevLocal}products-csv-options`,
    presentationsCsvOptions: `${baseDevLocal}presentations-csv-options`,
    discountsCsvOptions: `${baseDevLocal}discounts-csv-options`,
    presentationsSkusCsvOptions: `${baseDevLocal}presentations-skus-csv-options`,
    presentationsCombosCsvOptions: `${baseDevLocal}presentations-combos-csv-options`,
    presentationsDiscountsCsvOptions: `${baseDevLocal}presentations-discounts-csv-options`,

    productsCsvImport: `${baseDevLocal}products-csv-import`,
    presentationSkuCsvImport: `${baseDevLocal}presentation-sku-csv-import`,
    discountsCsvImport: `${baseDevLocal}discounts-csv-import`,
    presentationsCsvImport: `${baseDevLocal}presentations-csv-import`,
    presentationsDiscountsCsvImport: `${baseDevLocal}presentations-discounts-csv-import`,

    recipes: `${baseDevLocal}recipes`,
    suggestedProduct: `${baseDevLocal}suggest-products`
}

const environment = env => {
    switch (env) {
        case 'production':
            return production
        case 'develop':
            return develop
        default:
            return localHost
    }
}

module.exports = {
    stage: environment(process.env.REACT_APP_ENVIROMENT),
    passphrase,
}
